<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.offers')">Special Offers</inertia-link>
      <span class="text-indigo-400 font-medium">/Create</span>
    </h1>
    <Form mode="create" @submit="handleCreateOffer" :businessTypes="business_types" :errors="errors"/>
  </div>
</template>

<script>
import Form from './Form'
import Layout from '@/Shared/Admin/Layout'
export default {
  name: 'Create',
  layout: Layout,
  components: {
    Form
  },

  props: {
    errors: Object,
    business_types: {
      type: Object,
      required: true
    }
  },

  methods: {
    handleCreateOffer(offer) {
      this.$inertia.post(route('manage.offers.store'), offer)
    }

  }
}
</script>
